import React from "react";

const APP_CONF = {
  IS_NETPROBE: window.location.hostname == "netprobe.inrete.it" ? true : false,
  BASENAME: window.WEBAPP_BASENAME !== undefined ? window.WEBAPP_BASENAME : "",
  PUBLIC_PATH: (window.WEBAPP_BASENAME !== undefined ? window.WEBAPP_BASENAME : "") + "/",
  API_URL: window.API_SERVER_ADDRESS + "/" + window.API_VERSION,
  API_PATH: "/" + window.API_VERSION,
  IMG_URL: window.SERVER_ADDRESS + "/RRDgrcache",
  SERVER_URL: window.SERVER_ADDRESS,
  APP_COLORS: window.WEBAPP_COLORS,
  MLY_STATES_DICTIONARY: {
    W: { color: "success", text: "Working", value: 14 },
    R: { color: "success", text: "In recover from last error", value: 13 },
    S: { color: "success", text: "Spurious errors", value: 12 },
    M: { color: "danger", text: "Many errors", value: 11 },

    a: { color: "success", text: "Spurious anomalies", value: 9 },
    b: { color: "success", text: "Few anomalies", value: 10 },
    c: { color: "danger", text: "Many anomalies", value: 8 },
    d: { color: "danger", text: "Lot of errors", value: 7 },
    z: { color: "danger", text: "No measures data", value: 9 },

    A: { color: "danger", text: "Continuous errors", value: 6 },
    N: { color: "gray600", text: "Not enough data", value: 5 },
    U: { color: "gray600", text: "Not in scope", value: 4 },
    F: { color: "danger", text: "Far away", value: 3 },
    X: { color: "gray600", text: "BSSID not visible", value: 2 },
    NA: { color: "gray600", text: "-", value: 1 },
  },
  SETTINGS_NAME: {
    manual: { text: "Manual" },
    SD: { text: "Software defined" },
    deployed: { label: "Deployed", text: "deployed" },
    not_deployed: { label: "Not deployed" },
    maintenance: { label: "Maintenance" },
  },
  FCA_NAME: {
    FCAGuest: { text: "FCA-Guest", test: "FCAGuestCPortal, FCAGuest" },
    FCAPEAPinternalPage: { text: "FG-WiFi", test: "FCAPEAPinternalPage" },
  },
  STATIC_PAGE: {
    expired: {
      title: "Account expired",
      text: (
        <p>
          Cloud services for your account are expired.
          <br />
          You can no longer access the results of the measure from this web panel, but you
          will always be able to access them directly from your device.
          <br />
          To renew the subscription and continue using Cloud Services, please
          <a href="mailto:info@inrete.eu">
            {" "}
            <strong>contact us</strong>
          </a>
          .
        </p>
      ),
    },
    migration: {
      title: "Down for planned maintenance",
      text: (
        <div>
          <p>
            The site is currently down for planned maintenance.
            <br />
            We expect to be back in a couple of hours.
          </p>
          <p>Thanks for your patience.</p>
        </div>
      ),
    },
  },
  CSV_data: (
    <div className="text-left">
      Download measure detail as CSV. <br />
      Measures times are in UTC. <br />
      Steps times are in milliseconds. <br />
      The CSV file follows the RFC4180 standard.
    </div>
  ),
  CSV_no_data: "No measures in this time interval: CSV not available",
};

export default APP_CONF;
